export default __webpack_public_path__ + "3f2f9d8510be721862aa0502fc1c840a.svg";